import React from 'react'
//TODO needed?
import '../../App.css'

export default function Products(){
    return (
        <h1 className='products'>PRODUCTS</h1>
    )
}